import type { AppThunk } from '@core/core/store'

import { getAllProjectTypesApi } from '../../api'
import { projectTypesSlice } from './projectTypesSlice'

const { addProjectTypes } = projectTypesSlice.actions

export const getProjectTypes = (): AppThunk => dispatch => {
  getAllProjectTypesApi()
    .then(types => dispatch(addProjectTypes(types)))
    .catch(console.error)
}
